module.exports = __webpack_public_path__ + "static/lif-response-2-edf364c2be161bee87fdaedad2a7a8a7.mp4";